export const Logos = ({ boxed = false, size = "h-9" }) => (
  <span className="flex items-center gap-2">
    <span className={boxed ? "bg-white px-1.5 py-1" : ""}>
      <img
        src="/sail-logo.png"
        alt="Steel Authority of India Limited"
        className={`${size} w-auto object-contain`}
      />
    </span>
    <span className={boxed ? "bg-white px-1.5 py-1" : ""}>
      <img
        src="/pravartanam-logo.webp"
        alt="SAIL Pravartanam"
        className={`${size} w-auto object-contain`}
      />
    </span>
  </span>
);
